import VehicleDetailBottomSheet from '@di-shared/features/about/DataExplore/VehicleDeleteBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function VehicleDetailBottomSheetPage() {
  const vin = (window as any).data.vin as string;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <VehicleDetailBottomSheet vin={vin} />
    </BottomSheetWebViewWrapper>
  );
}

export default VehicleDetailBottomSheetPage;
